module.exports = __webpack_public_path__ + "img/custtag.png";